import axios from 'axios'
import store from '@/store'
import router from "@/router";
import { attachNetworkQualityInterceptor } from '@/utils/networkQualityMonitor'

const authTenant = axios.create({})

attachNetworkQualityInterceptor(authTenant)

authTenant.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`
    config.headers.lang = store.getters['getLang']
    config.url = `${process.env.VUE_APP_PROTOCOL}://${store.getters['auth/getTenantHost']}/authentication/api/v1${config.url}`
    return config;
})

export default authTenant
